import React from 'react';
import { createRoot } from 'react-dom/client'; // Import ReactDOM directly
import './index.css';
import App from './App';

// In case of need to render the app in strictMode,
// wrap the App component into this component :
/*<React.StrictMode>*/

// Create a root instance using createRoot
const root = createRoot(document.getElementById('root'));

// Render the App component within the root
root.render(
  <>
    <script src='/config.js'></script>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </>
);
